import { refinementListFilter } from './filters/checkbox';
import { paginationFilter } from './filters/pagination';
import { priceRangeFilter } from './filters/price-range';
import { sortByFilter } from './filters/sort-by';
import { toggleFilter } from './filters/toggle';

interface LocationProps {
  href: string;
  pathname?: string;
  origin?: string;
}

type RefinementList = {
  [key: string]: Array<string>;
};

type ToggleProps = {
  [key: string]: boolean;
};

export interface RouteStateProps {
  [indexName: string]: {
    refinementList?: RefinementList;
    toggle?: ToggleProps;
    page?: number | string;
    sortBy?: string;
    range?: Record<string, string>;
  };
}

const createUrlContext = (
  location: LocationProps,
  routeState: RouteStateProps,
  indexName: string,
  region: string,
  categoryFiltersLabel = {}
) => {
  const { origin, pathname, href } = location;

  const effectivePathname = pathname || new URL(href).pathname;
  const effectiveOrigin = origin || new URL(href).origin;

  const urlSplit = effectivePathname.split('/');

  const isDevelopment = process.env.NODE_ENV === 'development';

  const urlCategoryOrigin = isDevelopment
    ? `${effectiveOrigin}/${urlSplit[1]}/${urlSplit[2]}`
    : `${effectiveOrigin}/${urlSplit[1]}`;

  const currentRouteState = routeState[indexName] || {};
  const { refinementList, page, toggle, sortBy, range } = currentRouteState;

  if (refinementList || page || toggle || sortBy || range) {
    let urlToConcatenate = decodeURIComponent(removePaginationInUrl(href));

    if (refinementList) {
      urlToConcatenate = refinementListFilter({
        routeStateRefinementList: refinementList,
        href: urlToConcatenate,
      });
    }

    if (toggle) {
      urlToConcatenate = toggleFilter({
        routeState: toggle,
        href: urlToConcatenate,
        region,
      });
    }

    if (sortBy) {
      urlToConcatenate = sortByFilter({
        routeState: sortBy,
        href: urlToConcatenate,
      });
    }

    if (page) {
      urlToConcatenate = paginationFilter({
        routeStatePage: page,
        href: urlToConcatenate,
      });
    }

    if (range) {
      urlToConcatenate = priceRangeFilter({
        routeState: range,
        href: urlToConcatenate,
      });
    }

    return urlToConcatenate;
  }

  return urlCategoryOrigin;
};

const removePaginationInUrl = (href: string) => {
  const url = new URL(href);
  url.searchParams.delete('page');

  return url.toString();
};

export default createUrlContext;
